module.exports = __webpack_public_path__ + "static/sharon-sketch-title-861aa3cc684cae8bbe693d29c22869e1.png";